import { getOppositeAlign, } from '../direction';
import { parseValueWithUnit } from './scaleProportionally';
export const getInputHeight = ({ inputHeightProps, height, isMobileView, }, formatCssValue, spx) => {
    const { inputHeightMobile, inputHeight } = inputHeightProps;
    const actualHeight = isMobileView
        ? inputHeightMobile || inputHeight || height
        : inputHeight || height;
    return formatCssValue
        ? formatCssValue(actualHeight, spx)
        : `${actualHeight}px`;
};
export const getLabelPadding = (labelPaddingProps, formatCssValue, spx) => {
    const { labelPadding, textAlignment, filesAlignment, alignment } = labelPaddingProps;
    const labelPaddingLimit = String(labelPadding).endsWith('spx') ? '20spx' : 20;
    const align = textAlignment || filesAlignment || alignment;
    switch (align) {
        case 'left':
            return formatCssValue
                ? formatCssValue(`0 ${labelPaddingLimit} 0 ${labelPadding}`, spx)
                : `0 ${labelPaddingLimit}px 0 ${labelPadding}px`;
        case 'right':
            return formatCssValue
                ? formatCssValue(`0 ${labelPadding} 0 ${labelPaddingLimit}`, spx)
                : `0 ${labelPadding}px 0 ${labelPaddingLimit}px`;
        default:
            return undefined;
    }
};
export const getRequiredIndicationDisplay = (styleProperties) => {
    const { txtlblrq } = styleProperties;
    return !txtlblrq || txtlblrq === 'transparent' ? 'none' : 'inline';
};
const LABEL_PADDING_LIMIT = 20;
export const getLabelPaddingsValues = ({ labelPadding, align, }) => {
    if (align === 'center') {
        return {
            '--labelPadding_start': 0,
            '--labelPadding_end': 0,
        };
    }
    const { value } = parseValueWithUnit(String(labelPadding), {
        fallbackValue: { value: 0, unit: 'px' },
    });
    return {
        [`--labelPadding_${align}`]: value,
        [`--labelPadding_${getOppositeAlign(align)}`]: LABEL_PADDING_LIMIT,
    };
};
const DEFAULT_PADDING = 3;
const PREFIX_PADDING = 50;
export const getTextPaddingsValues = ({ align, textPadding, hasPrefix, }) => {
    const { value } = parseValueWithUnit(String(textPadding), {
        fallbackValue: { value: DEFAULT_PADDING, unit: 'px' },
    });
    const addedPrefix = hasPrefix ? PREFIX_PADDING : 0;
    const isCenter = align === 'center';
    const paddingWithPrefix = value + addedPrefix;
    const defaulPaddingWithPrefix = DEFAULT_PADDING + addedPrefix;
    if (isCenter) {
        return {
            '--textPadding': DEFAULT_PADDING,
            '--textPadding_start': defaulPaddingWithPrefix,
            '--textPadding_end': defaulPaddingWithPrefix,
        };
    }
    return {
        '--textPadding': DEFAULT_PADDING,
        [`--textPadding_${align}`]: paddingWithPrefix,
        [`--textPadding_${getOppositeAlign(align)}`]: DEFAULT_PADDING,
    };
};
export const convertPhysicalInputAlignmentToDirection = (physicalAlignment) => {
    return physicalAlignment === 'right' ? 'rtl' : 'inherit';
};
export const convertPhysicalInputAlignmentToLogical = (physicalAlignment) => {
    return physicalAlignment === 'center' ? 'center' : 'start';
};
//# sourceMappingURL=inputUtils.js.map